import React from 'react';

const Enquiry = () => {
  const handleWhatsAppSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);

    const name = data.get('name') || '';
    const email = data.get('email') || '';
    const phone = data.get('phone') || '';
    const subject = data.get('subject') || '';
    const message = data.get('message') || '';

    const composedMessage =
      `Hello, I’d like to enquire about Shree Swami Samarth PG.\n\n` +
      `Name: ${name}\n` +
      `Email: ${email}\n` +
      `Phone: ${phone}\n` +
      `Subject: ${subject}\n` +
      `Message: ${message}`;

    // WhatsApp expects country code without '+'
    const whatsappNumber = '919209169761';
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(composedMessage)}`;

    // Try opening in a new tab (desktop) or app (mobile). Fallback to same tab if blocked.
    const opened = window.open(url, '_blank');
    if (!opened) {
      window.location.href = url;
    }

    form.reset();
  };

  return (
    <>
      <section
        className="page-title"
        style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
      >
        <div className="auto-container">
          <h1>Enquiry</h1>
        </div>
      </section>

      <section className="contact-section">
        <div className="auto-container">
          <div className="row clearfix">

            {/* Info Column */}
            <div className="info-column col-md-5 col-sm-12 col-xs-12">
              <img src="./images/enquiry.jpg" alt="Enquiry" />
            </div>

            {/* Form Column */}
            <div className="form-column col-md-7 col-sm-12 col-xs-12">
              <div className="column-inner">
                <div className="form-title">
                  <h2>Contact Form</h2>
                  <div className="separator"></div>
                  <div className="text">
                    Reach Out to Shree Swami Samarth PG<br />
                    Our Team Is Here to Assist You
                  </div>
                </div>

                {/* Contact Form */}
                <div className="contact-form">
                  <form id="contact-form" onSubmit={handleWhatsAppSubmit}>
                    <div className="row clearfix">
                      <div className="col-md-6 col-sm-6 col-xs-12 form-group">
                        <input type="text" name="name" placeholder="Your Name" required />
                      </div>

                      <div className="col-md-6 col-sm-6 col-xs-12 form-group">
                        <input type="email" name="email" placeholder="Email address" required />
                      </div>

                      <div className="col-md-6 col-sm-6 col-xs-12 form-group">
                        <input type="text" name="phone" placeholder="Phone" required />
                      </div>

                      <div className="col-md-6 col-sm-6 col-xs-12 form-group">
                        <input type="text" name="subject" placeholder="Subject" required />
                      </div>

                      <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                        <textarea name="message" placeholder="Message" rows={5}></textarea>
                      </div>

                      <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                        <button className="theme-btn btn-style-one" type="submit" name="submit-form">
                          Send via WhatsApp
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                {/* End Contact Form */}
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Enquiry;
